
module.exports = {
    prefFields: [
        'sms',
        'connectionsVisibility',
        'groupVisibility',
        'hideInterestPopup',
        'groupMsgNotifications',
        'digestInterval',
        'pendingConnections',
        'careerAlerts',
        'offerAlerts',
        'messageNotifications'
    ],
    profileFields: [
        'phone',
        'phoneCountry',
        'profileEmail'
    ]
};
